import { Objects } from '../util/objects';

export abstract class AbstractIntervalRequester {

    protected _timer;
    protected _interval: number = 500; // milliseconds

    public isStarted(): boolean {
        return this._timer != null;
    }

    protected start(): boolean {

        if (this._timer) {
            console.log("already started timer");
            return false;
        }

        this._timer = setInterval(() => this.run(), this._interval);

        return !Objects.isEmpty(this._timer);
    }

    protected stop(): void {
        if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
        }
    }

    protected restart(): void {
        this.stop();
        setTimeout(() => this.start(), 500);
    }

    protected run(): void {
        throw new Error("Need overwrite to run!!");
    }
}